import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './InfoTooltip.scss';

const InfoTooltip = (props) => {
  const { className, ...other } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <Tooltip
      isOpen={tooltipOpen}
      toggle={toggle}
      className={classNames('tooltip-info', className)}
      {...other} // eslint-disable-line
    />
  );
};

InfoTooltip.defaultProps = {
  className: '',
  target: undefined,
  placement: undefined,
};

InfoTooltip.propTypes = {
  className: PropTypes.string,
  target: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Element),
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default InfoTooltip;
